/* eslint-disable no-lone-blocks */
import React, { Component } from "react";
import Helpers from "util/helpers";

class GuideManagers extends Component {
  state = {
    nodes: [],
  };

  componentDidMount = () => {
    this.buildNodes();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      prevProps.data !== this.props.data ||
      prevProps.isOtosanContact !== this.props.isOtosanContact
    ) {
      // top level maangers
      this.buildNodes();
    }
  };

  componentWillUnmount = () => {
    // this.setState({ nodes: null });
  };

  buildNodes = () => {
    let nodes = [];

    debugger;

    let fixedSearchTerm = Helpers.getTurkishCharaterFixedList(
      this.state.searchTerm,
      []
    );

    this.props.data
      .filter((e) => {
        return (
          e.reportManager === null &&
          e.isOtosanContact === this.props.isOtosanContact
        );
      })
      .filter((contact) => {
        if (!contact.fullname) return false;
        let fixedName = Helpers.getTurkishCharaterFixedList(contact.fullname);
        let splittedName = fixedName.split(" ");

        for (let i = 0; i < splittedName.length; i++) {
          if (!fixedSearchTerm.includes(" ")) {
            if (splittedName[i].startsWith(fixedSearchTerm)) return true;
          } else {
            // search in all name combinations
            let nameCombinations = Helpers.combine(splittedName, 1);
            for (let i = 0; i < nameCombinations.length; i++) {
              if (nameCombinations[i].join(" ").startsWith(fixedSearchTerm))
                return true;
            }
          }
        }
        return false;
      })
      .forEach((tlm) => {
        let node = {
          id: tlm.id,
          name: tlm.fullname,
          department: tlm.department,
          position: tlm.position,
          managerId: null,
          nodes: this.getNodes(this.getReporters(this.props.data, tlm.id)),
        };
        nodes.push(node);
      });

    const sorted = nodes.sort((a, b) => {
      return a.name - b.name;
    });

    this.setState({ nodes: sorted });
  };

  subMenuToggle = (event) => {
    // console.dir(event.target);
    // Only watch clicks on .toggle-switch
    if (!event.target.classList.contains("toggle-switch")) {
      return;
    }

    // Prevent the actual click on the link

    // Toggle .is-active on parent <li> element
    const subNodes = event.target.parentNode.parentNode.querySelectorAll(
      ":scope > ul"
    );
    const className = "is-active";

    subNodes.forEach((p) => p.classList.toggle(className));

    event.target.parentNode.children[0].classList.toggle("minus");
    event.target.parentNode.classList.toggle("active");

    // Only open the next direct ul
    // parent.querySelectorAll(":scope > ul").forEach((element) => {
    //   element.classList.toggle(className);
    // });

    event.stopPropagation();
  };

  handleSelectManager = (e, mgrId) => {
    // console.dir(e.target);
    this.props.onSelectManager(mgrId);
    this.subMenuToggle(e);
    e.stopPropagation();
  };

  getReporters = (data, mgrId) => {
    let reporters = data
      .filter((e) => e.reportManager !== null)
      .filter((e) => e.reportManager.id === mgrId);

    return reporters;
  };

  getNodes = (reporters) => {
    let nodes = [];
    reporters.forEach((e) => {
      let node = {
        id: e.id,
        name: e.fullname,
        managerId: e.reportManager ? e.reportManager.id : null,
        department: e.department,
        position: e.position,
        nodes: this.getNodes(this.getReporters(this.props.data, e.id)),
      };

      nodes.push(node);
    });
    return nodes;
  };

  renderNodeIcon = (n) => {

    // if (n.id === "47f45e36-ef59-f011-bec2-000d3a48bf37") debugger

    if (!n.nodes) return null;
    let hasGrandChildren = false;
    // n.nodes.forEach((ch) => {
    //   if (ch.nodes.length > 0) {
    //     hasGrandChildren = true;
    //   }
    // });

    if (n.nodes.length !== 0) hasGrandChildren = true;

    if (hasGrandChildren) {
      return (
        <span
          onClick={this.subMenuToggle}
          className="toggle-switch iconmford fo-icon-add"
        ></span>
      );
    } else {
      return (
        <span
          className="toggle-switch iconmford fo-icon-remove "
          style={{ paddingRight: "5px" }}
        ></span>
      );
    }
  };

  capitalizeEachWord(text) {
    if (!text) return "";

    return text
      .split(" ")
      .map((word) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }

  renderNodes = (nodes) => {
    let fNodes = nodes.map((n) => {



      // if (n.nodes.length === 0) {
      //   return null;
      // }

      let classList = "nav-dropdown-two";
      if (n.managerId === null) {
        classList = "leftsidequide";
      }

      return (
        <ul
          key={n.id}
          className={classList}
          onClick={(e) => this.handleSelectManager(e, n.id)}
        // data={n.id}
        >
          <li>
            <div className="quideLinkArea node" style={{ lineHeight: "30px" }}>
              {this.renderNodeIcon(n)}
              <span className="toggle-switch guideTitle info" style={{ display: "flex", flexDirection: "column" }}>
                <span className="titleGuidColor name hide">{this.capitalizeEachWord(n.department)}</span>
                <span className="dept">{this.capitalizeEachWord(n.name)}</span>
                <span className="pos" style={{ fontSize: "10px", textAlign: "left", border: "none" }}>{this.capitalizeEachWord(n.position)}</span>

              </span>
            </div>
            {n.nodes.length > 0 ? this.renderNodes(n.nodes) : null}
          </li>
        </ul >
      );
    });

    return fNodes;
  };

  render() {
    if (!this.state.nodes) {
      return null;
    }

    // console.log(this.state.nodes);

    return (
      <div className="row mb-4">
        <style>{`
          .treeview-container {
            font-family: 'Segoe UI', sans-serif;
            background: #f8f9fa;
            padding: 20px;
            border-radius: 12px;
          }
          .treeview-container ul {
            list-style: none;
            padding-left: 1rem;
            margin: 0;
          }
          .treeview-container li {
            margin-bottom: 0.5rem;
          }
          .node {
            display: flex;
            align-items: center;
            padding: 10px 14px;
            background: #ffffff;
            border-radius: 8px;
            box-shadow: 0 2px 5px rgba(0,0,0,0.06);
            cursor: pointer;
            transition: background 0.2s ease;
            margin-top:5px;
          }
          .node:hover {
            background: #e9ecef;
          }
          .toggle-switch {
            width: 20px;
            margin-right: 10px;
            font-size: 14px;
            user-select: none;
          }
          li.expanded > .node > .toggle-switch {
            transform: rotate(90deg);
          }
          .info {
            display: flex;
            flex-direction: column;
          }
          .name {
            font-weight: 600;
            color: #343a40;
                font-size: 12px;
                height:25px
          }
          .dept {
            font-size: 12px;
            color: #6c757d;
            height: 25px;
          }
          .pos {
            font-size: 11px;
            color: #adb5bd;
            height: 25px;
          }
          .children {
            display: none;
            margin-left: 20px;
          }
          li.expanded > .children {
            display: block;
          }
            .container{
    max-width: 100%;
            }
    .toggle-switch{color:#000}
        `}</style>

        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="PlatinBlank">
            {this.renderNodes(this.state.nodes)}
          </div>
        </div>
      </div>
    );
  }
}

export default GuideManagers;
